import 'uplot/dist/uPlot.min.css';
import React from "react";
import FilterContent from "./FilterContent";

export default function filterPage() {
  return (
    <FilterContent/>
  );
}
